import React from 'react'
import './FeaturedOnNewspaper.css'

function FeaturedOnNewspaper() {
    return (
        <div>
            <h1 className="header1">Featured in the follwing newspaper</h1>
            <div className="paper">Prothom Alo</div>
            <div className="paper">Janakantha</div>
            <div className="paper">Daily Star</div>
            <div className="paper">Guardian</div>
            <div className="paper">BusinessWeek</div>
        </div>
    )
}

export default FeaturedOnNewspaper
